__turbopack_context__.v({
  "art": "j5d_EG_art",
  "card": "j5d_EG_card",
  "cardBody": "j5d_EG_cardBody",
  "cardLink": "j5d_EG_cardLink",
  "cardTitle": "j5d_EG_cardTitle",
  "copy": "j5d_EG_copy",
  "dataGlow": "j5d_EG_dataGlow",
  "dataRing": "j5d_EG_dataRing",
  "eyebrow": "j5d_EG_eyebrow",
  "heading": "j5d_EG_heading",
  "intro": "j5d_EG_intro",
  "listFade": "j5d_EG_listFade",
  "photo": "j5d_EG_photo",
  "plugArt": "j5d_EG_plugArt",
  "reasons": "j5d_EG_reasons",
  "section": "j5d_EG_section",
  "stage": "j5d_EG_stage",
  "title": "j5d_EG_title",
});
